<div class="nav-container-2 view-container" [hidden]="selectedTabIndex==0">
  <div class="row">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pl-3 pr-3">
          <mat-tab-group (selectedTabChange)="viewTabClick($event)" [(selectedIndex)]="selectedTabIndex">
              <mat-tab label="" id="tabMaterialChallan"></mat-tab>
              <mat-tab *ngFor="let tab of viewTabs; let index = index" [label]="tab" class="tabsrow">
                  <ng-template mat-tab-label>
                      {{tab.ccnNo}}
                      <i class="fa fa-times-circle ml-3" aria-hidden="true" (click)="closeViewTab(tab)"></i>
                  </ng-template>
              </mat-tab>
          </mat-tab-group>
      </div>
  </div>
</div>
<div class="" *ngIf="selectedTabIndex==0">
  <div class="nav-container-1">
      <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 tab-container">
              <mat-tab-group (selectedTabChange)="tabClick($event)" [(selectedIndex)]="selectedRootIndex">
                  <mat-tab label="For Action">
                      <ng-template mat-tab-label id="lblChallanList">
                          For Action <span>{{forActionList.length}}</span>
                      </ng-template>
                  </mat-tab>
                  <mat-tab label="Approved">
                      <ng-template mat-tab-label id="lblChallanList">
                          Approved <span>{{approvedList.length}}</span>
                      </ng-template>
                  </mat-tab>
                  <mat-tab label="Rejected">
                      <ng-template mat-tab-label id="lblChallanList">
                          Rejected <span>{{rejectedList.length}}</span>
                      </ng-template>
                  </mat-tab>
                  <mat-tab label="Published">
                      <ng-template mat-tab-label id="lblChallanList">
                          Published <span>{{publishedList.length}}</span>
                      </ng-template>
                  </mat-tab>
                  <mat-tab label="All">
                      <ng-template mat-tab-label id="lblChallanList">
                          All <span>{{data.length}}</span>
                      </ng-template>
                  </mat-tab>
              </mat-tab-group>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 icons-container">
              <div class="d-flex justify-content-end">
                  <mat-button-toggle-group #group="matButtonToggleGroup" class="sche-toggle-btn" style="width:100%" [value]='ccnType' (change)="onTypeChange($event)">
                      <mat-button-toggle *ngFor="let type of ccnTypeList;" value="{{type.deD_Id}}" title={{type.deD_Description}}>
                          {{type.deD_Description}}
                      </mat-button-toggle>
                  </mat-button-toggle-group>
                  <div class="d-none d-md-block">
                      <i class="fa fa-search" title="Search" [ngClass]="{'active':isSearch}" aria-hidden="true" id="ibtSearch" aria-hidden="true" label="Advance Search" (click)="advanceSearch()"></i>
                      <i class="fa fa-ban" aria-hidden="true" title="Reject" *ngIf="selectedRootIndex==0||selectedRootIndex==1" (click)="approveAllCCN(false)"></i>
                      <i class="fa fa-check-circle-o" aria-hidden="true" *ngIf="selectedRootIndex==0||selectedRootIndex==2" title="Approve" (click)="approveAllCCN(true)"></i>
                      <i class="fa fa-newspaper-o" aria-hidden="true" *ngIf="selectedRootIndex==1" title="Publish" (click)="publishAllCCN(true)"></i>
                      <i class="fa fa-plus-circle" (click)="changeControlNote()" aria-hidden="true" title="Create"></i>
                  </div>
              </div>
              <div class="d-block d-md-none d-flex justify-content-end">
                  <i [matMenuTriggerFor]="moreIcons" class="fa fa-ellipsis-v" aria-hidden="true"></i>
                  <mat-menu #moreIcons="matMenu" class="more-actions d-block d-md-none">
                      <button mat-menu-item (click)="advanceSearch()">
                          <i class="fa fa-search" title="Search" aria-hidden="true" id="lblASRAllCount" aria-hidden="true" title="Advance Search"></i> Advance Search</button>
                      <button mat-menu-item (click)="approveAllCCN(false)" *ngIf="selectedRootIndex==0||selectedRootIndex==1">
                          <i class="fa fa-ban" title="Reject" id="ibtASRAdd" aria-hidden="true"></i>
                          Reject</button>
                      <button mat-menu-item (click)="approveAllCCN(true)" *ngIf="selectedRootIndex==0||selectedRootIndex==2">
                          <i class="fa fa-check-circle-o" title="Approve" id="ibtASRAdd" aria-hidden="true"></i>
                          Approve</button>
                      <button mat-menu-item (click)="publishAllCCN(true)" *ngIf="selectedRootIndex==1">
                          <i class="fa fa-newspaper-o" title="Publish" id="ibtASRAdd" aria-hidden="true"></i>
                          Publish</button>
                      <button mat-menu-item (click)="changeControlNote()">
                          <i class="fa fa-plus-circle" title="Create" id="ibtASRAdd" aria-hidden="true"></i>
                          Create</button>
                  </mat-menu>
              </div>
          </div>
      </div>
  </div>
  <div>
      <div *ngIf="isSearch">
          <app-ccn-advance-search [searchList]="ccnList" (advancedSearchStatus)="closeAdvSearch($event)">
          </app-ccn-advance-search>
      </div>
      <div [ngClass]="{'kgrid-fullscreen' : enableFullscreen}">
          <kendo-grid #docGrid [kendoGridBinding]="ccnList" [style.maxHeight]="540" [pageable]="true" [pageSize]="pageSize" id="documentLandingGrid" [sortable]="true" [resizable]="true" [reorderable]="true" [filterable]="enableFilter" [selectable]="true" (selectionChange)="onSelectionChange($event)" [scrollable]="true" class="form-group-grid auto-complete-equal k-resizable-grid kg-hover-icon" [height]="540">
              <ng-template kendoPagerTemplate>
                  <div class="k-pager-left">
                      <kendo-pager-info></kendo-pager-info>
                  </div>
                  <div class="k-pager-right">
                      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                      <kendo-pager-input></kendo-pager-input>
                      <kendo-pager-next-buttons></kendo-pager-next-buttons>
                  </div>
              </ng-template>
              <ng-template kendoGridToolbarTemplate>
                  <div class="k-grid-toolbar-content d-flex">
                      <div class="flex-grow-1 title-container">
                          <p class="title">Details -</p>
                          <div class="pagination-container details-section">
                              <p class="d-none d-sm-flex">Viewing last</p>
                              <kendo-dropdownlist [data]='noOfDays' [value]="LastViewingRecord" (valueChange)="lastviewingrecordsmethod($event)" class="eip-mr-5 eip-ml-5" id="lblViewingLastDaysRecords" style="margin: 0px;"> </kendo-dropdownlist>
                              <p class="d-none d-sm-flex">days records</p>
                          </div>
                      </div>
                      <div class="flex-grow-1 mat-panel-headerbar"></div>
                      <div class="pagination-container">
                          <p id="lblShowDetails">Show</p>
                          <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                          </kendo-pager-page-sizes>
                          <span>Items</span>
                      </div>
                      <div class="divider-container d-none d-md-block" id="imgDivider">
                          <span></span>
                      </div>
                      <div class="icons-container">
                          <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
                          <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">
                              <div class="icon-wrap">
                                  <i class="fa fa-filter" title="Filter" (click)="toggleFilter()" aria-hidden="true"></i>
                                  <span class="list-icon-name">Filter</span>
                              </div>
                              <div class="icon-wrap">
                                  <i class="fa " [ngClass]="enableFullscreen ? 'fa-compress': ' fa-expand'" aria-hidden="true" title="{{ !enableFullscreen ? 'Expand' : 'Collapse' }}" (click)="toggleFullscreen()"></i>
                                  <span class="list-icon-name">{{ !enableFullscreen ? 'Expand' : 'Collapse' }}</span>
                              </div>
                          </div>
                      </div>
                  </div>
              </ng-template>
              <kendo-grid-checkbox-column showSelectAll="true" [width]="40"></kendo-grid-checkbox-column>
              <kendo-grid-column field="ccnNo" title="Change No." [width]="190">
                  <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                      <i aria-hidden="true" [ngClass]="dataItem.attachmentsCount>0?'eip-link':''"  class="fa fa-paperclip fs-16 eip-mr-5" (click)="dataItem.attachmentsCount>0?viewAttachmentClick(dataItem):$event.stopPropagation()"></i>
                      <span class="no-wrap eip-link" (click)="viewCCN(dataItem)" eipTooltip="{{dataItem.ccnNo}}" eipTooltipPosition="auto">
                          {{dataItem.ccnNo}}</span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="ccnTitle" title="Title" [width]="200">
                  <ng-template kendoGridCellTemplate let-dataItem>
                      <span class="no-wrap" eipTooltip="{{dataItem.ccnTitle}}" eipTooltipPosition="auto">{{dataItem.ccnTitle}} </span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="ccnRevNo" title="Revision No" [width]="60">
                  <ng-template kendoGridCellTemplate let-dataItem>
                      <span class="no-wrap" eipTooltip="{{dataItem.ccnRevNo}}" eipTooltipPosition="auto">{{dataItem.ccnRevNo}} </span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="publishDate" title="CCN Date" [width]="70" type="date" filter="date" format="{0:dd-MMM-yyyy}" [filterable]="false">
                  <ng-template kendoGridCellTemplate let-dataItem>
                      <span class="no-wrap" eipTooltip="{{dataItem.publishDate | date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.publishDate | date:'dd-MMM-yyyy'}} </span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="manHours" title="Man Hours" [width]="60" type="number" [sortable]="false">
                  <ng-template kendoGridCellTemplate let-dataItem>
                      <span class="no-wrap" eipTooltip="{{dataItem.manHours}}" eipTooltipPosition="auto">{{dataItem.manHours}} </span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="originator" title="Originator" [width]="100">
                  <ng-template kendoGridCellTemplate let-dataItem>
                      <span class="no-wrap" eipTooltip="{{dataItem.originator}}" eipTooltipPosition="auto">{{dataItem.originator}} </span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="discipline" title="Discipline" [width]="100">
                  <ng-template kendoGridCellTemplate let-dataItem>
                      <span class="no-wrap" eipTooltip="{{dataItem.discipline}}" eipTooltipPosition="auto">{{dataItem.discipline}} </span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="status" title="Status" [width]="100" id="GrlblStatus">
                  <ng-template kendoGridCellTemplate let-dataItem>
                      <span class="k-grid-status" [class.cancelled]="" [class.rejected]="dataItem.status=='Pending for manhour'" [class.submitted]="dataItem.status=='Pending for Submission'" [class.draft]="" [class.approved]="dataItem.status=='Pending for publish'" [class.send_back]="" [class.hold]="" [class.accepted]="dataItem.status=='Completed'" [class.closed]="" [class.amber]="dataItem.status=='Pending for Approval'" eipTooltip="{{dataItem.status}}" eipTooltipPosition="auto"></span>
                      <span class="no-wrap" eipTooltip="{{dataItem.status}}" eipTooltipPosition="auto">{{dataItem.status}}</span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="action" title="Action" [width]="100">
                  <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                      <div #divIcon class="icon-container">
                          <!-- <i class="fa fa-print" title="Print" *ngIf="dataItem.submitDate!=null" (click)="printCCN(dataItem)" aria-hidden="true" style="font-size: 1.25em; cursor: pointer;"></i>
                          <i class="fa fa-pencil" title="Edit" *ngIf="dataItem.status!='Completed'" (click)="editCCN(dataItem)" aria-hidden="true" style="font-size: 1.25em; cursor: pointer;"></i>
                          <i class="fa fa-ban" title="Reject" *ngIf="dataItem.submitDate!=null && (dataItem.ccnProgress == 'For Action'||dataItem.ccnProgress == 'Approved') && dataItem.status=='Pending for Approval'" (click)="approveCCN(dataItem,false)" aria-hidden="true" style="font-size: 1.25em; cursor: pointer;"></i>
                          <i class="fa fa-check" title="Approve" *ngIf="dataItem.status=='Pending for Approval'" (click)="approveCCN(dataItem,true)" aria-hidden="true" style="font-size: 1.25em; cursor: pointer;"></i>
                          <i class="fa fa-newspaper-o" title="Publish" *ngIf="dataItem.ccnProgress == 'Approved' && dataItem.status=='Pending for publish'" (click)="publishCCN(dataItem)" aria-hidden="true" style="font-size: 1.25em; cursor: pointer;"></i> -->
                          <!-- *ngIf="dataItem.submitDate!=null"  -->
                          <i class="fa fa-print" title="Print" (click)="printCCN(dataItem)" *ngIf="dataItem.status=='Pending for publish'"  aria-hidden="true" style="font-size: 1.25em; cursor: pointer;"></i>
                          <i class="fa fa-pencil" title="Edit" *ngIf="dataItem.status!='Completed'" (click)="editCCN(dataItem)" aria-hidden="true" style="font-size: 1.25em; cursor: pointer;"></i>
                          <i class="fa fa-ban" title="Reject" *ngIf="dataItem.submitDate!=null && (dataItem.ccnProgress == 'For Action'||dataItem.ccnProgress == 'Approved') && dataItem.status=='Pending for Approval'" (click)="approveCCN(dataItem,false)" aria-hidden="true" style="font-size: 1.25em; cursor: pointer;"></i>
                          <i class="fa fa-check" title="Approve" *ngIf="dataItem.status=='Pending for Approval'" (click)="approveCCN(dataItem,true)" aria-hidden="true" style="font-size: 1.25em; cursor: pointer;"></i>
                          <!-- dataItem.ccnProgress == 'Approved' && -->
                          <i class="fa fa-newspaper-o" title="Publish" *ngIf="dataItem.status=='Pending for publish'" (click)="publishCCN(dataItem)" aria-hidden="true" style="font-size: 1.25em; cursor: pointer;"></i> 
                     
                     
                        </div>
                  </ng-template>
              </kendo-grid-column>
          </kendo-grid>
      </div>
  </div>
</div>
<div *ngIf="selectedTabIndex!=0">
  <app-ccn-view [viewData]="viewData"></app-ccn-view>
</div>